// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"c1fb3439","274":"1117a089","337":"9c69472b","353":"488e705a","504":"61561f83","729":"aebd08bb"}[chunkId] + ".chunk.css";
};